module.exports = __webpack_public_path__ + "img/action-arrow-left.1d77407c.png";